import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../contexts/languageContext';
import { trackEvent } from '../../lib/analytics';
import { shouldShowEntryPoints } from './cvChatClient';
import './CVChat.scss';

/**
 * Fumetto di dialogo sull'angolo della foto profilo: porta a /talktome.
 *
 * Va inserito dentro un contenitore con classe cv-chat-bubble-anchor, che
 * fornisce il riferimento di posizione e, tramite container query, la scala:
 * l'icona si dimensiona in proporzione all'immagine invece di avere una
 * dimensione fissa.
 *
 * L'animazione sta sullo <span> interno e non sul link: le utility Bootstrap di
 * posizionamento usano `transform ... !important`, e una dichiarazione
 * !important vince sulle animazioni. Animare l'elemento posizionato non
 * produrrebbe alcun movimento.
 */
const TalkToMeBubble: React.FC = () => {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();

  // In produzione senza backend non mostro un invito che porterebbe a una pagina
  // inutilizzabile; in sviluppo resta visibile per poterci lavorare.
  if (!shouldShowEntryPoints()) return null;

  return (
    <Link
      className="cv-chat-bubble position-absolute top-30 start-75 translate-middle no-print"
      to={{ pathname: '/talktome', search: `?${searchParams.toString()}` }}
      title={t('talkToMeNavLabel')}
      aria-label={t('talkToMeNavLabel')}
      onClick={() => {
        try {
          trackEvent('talktome_entry_click', { source: 'profile_bubble' });
        } catch {
          // noop
        }
      }}
    >
      <span className="cv-chat-bubble__icon" aria-hidden="true">
        <FontAwesomeIcon icon={faCommentDots} />
      </span>
    </Link>
  );
};

export default TalkToMeBubble;
